// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"40a3895e","453":"742f3f50","478":"6658ca9d","587":"ef78e228","607":"c4a3085f","702":"0959c8cf","865":"bd004a65"}[chunkId] + ".chunk.js";
};